<template>
  <div class="charge-banner">
    <img :src="chargeBanner" alt="" />
    <div class="absolute">
      <div class="title">智能充电</div>
      <div class="text">
        智慧平台与小区充电系统同步联动，随时查看充电区域运行状态，所有充电区域全局宏观调控，智能充电管理系统，攻克小区充电难题，再无充电烦恼，实现充电区域增值创收。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import chargeBanner from "../../../../assets/programme/chargeBanner.png";

export default {
  setup() {
    return reactive({
      chargeBanner: chargeBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.charge-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .charge-banner {
    min-width: 1180px;
  }
}
.charge-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248efb;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248efb;
}
.absolute .experience {
  margin-top: 20px;
  font-size: 16px;
  color: #248efb;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248efb;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
